import { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import UserContext from "../../contexts/UserContext";
import Preloader from "../../components/Preloader";
import NetworkError from "../../components/NetworkError";
import { textes } from "../../constants/textes";
import { config } from "../../constants/config";
import { toast } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import { Spinner } from "react-bootstrap";
import { TextParagraph } from "react-bootstrap-icons";
import { confirmAlert } from "react-confirm-alert";
import 'react-confirm-alert/src/react-confirm-alert.css';


export default function TypeForfaitInfos({ codetype }) {
    // states
    const { user, logoutUser } = useContext(UserContext);
    const navigate = useNavigate();
    const [loading, setLoading] = useState(true);
    const [fetching, setFetching] = useState(false);
    const [deleting, setDeleting] = useState(false);
    const [editedstate, setEditedstate] = useState(false);
    const [error, setError] = useState(false);

    const [name, setName] = useState("");
    const [abrev, setAbrev] = useState("");



    const getCompte = async () => {

        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
        myHeaders.append("Authorization", user.token);
        myHeaders.append("cpte", user.code);
        myHeaders.append("prof", user.profil);
        myHeaders.append("conn", user.token);

        var requestOptions = {
            method: 'GET',
            headers: myHeaders,
            // body: urlencoded,
            redirect: 'follow'
        };

        // console.log("data send", urlencoded)

        await fetch(`${config.domain.BASE_URL}/${config.domain.PROJECT}/compte/profile`, requestOptions).then((response) => {

            if (response?.status !== 200) {
                // console.log("response get account", response);
            } else {
                response.json().then(async (data) => {
                    if (data?.head) {
                        // let body = data?.body;
                    } else {
                        if (data?.body?.data?.msg === "expiredsession") {
                            logoutUser();
                            navigate("/", { state: { msg: textes.fr.sessionexpmsg } });
                        } else {
                            // console.log("fail request get account");
                        }
                    }
                })
            }

        })
            .catch((err) => {
                // console.log("error", err);
            });
    }

    const showErrorMessage = (msg) => {
        toast.error(msg, {
            position: toast.POSITION.BOTTOM_CENTER,
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
        });
    }

    const showSuccesMessage = (msg) => {
        toast.success(msg, {
            position: toast.POSITION.BOTTOM_CENTER,
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
        });
    }


    const getElement = async () => {
        setLoading(true);

        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
        myHeaders.append("token", config.domain.PUBLICKEY);
        myHeaders.append("apikey", user.token);
        myHeaders.append("cpte", user.code);
        myHeaders.append("prof", user.profil);
        myHeaders.append("conn", user.espace);

        var requestOptions = {
            method: 'GET',
            headers: myHeaders,
            // body: urlencoded,
            redirect: 'follow'
        };

        // console.log("data send", urlencoded)
        await fetch(`${config.domain.BASE_URL}/${config.domain.PROJECT}/nouns/${codetype}`, requestOptions).then((response) => {
            if (response?.status === 200) {
                response.json().then(async (data) => {
                    // console.log("resonse jsondecode", data);
                    if (data?.head) {
                        let body = data?.body?.data[0];

                        setName(body?.lib !== null ? body?.lib : "");
                        setAbrev(body?.abrev !== null ? body?.abrev : "");

                        setLoading(false);
                    } else {
                        if (data?.body?.data?.msg === "expiredsession") {
                            logoutUser();
                            navigate("/", { state: { msg: config.texts.sessionexpmsg } });
                        } else {
                            setError(true);
                            setLoading(false);
                        }
                    }
                });
            } else if (response?.status === 401) {
                logoutUser();
                navigate("/", { state: { msg: config.texts.sessionexpmsg } });
            } else {
                setError(true);
                setLoading(false);
            }

        }).catch((err) => {
            // console.log("error", err);
            setError(true);
            setLoading(false);
        });
    }


    // comportements
    useEffect(() => {
        getCompte();
        getElement();
    }, []);


    const handleDelete = async () => {
        confirmAlert({
            title: textes.fr.deletetypeforfaitlabel,
            message: textes.fr.deletetypeforfaitlabeldesc,
            buttons: [
                {
                    label: textes.fr.confirm,
                    style: {
                        backgroundColor: '#01203f',
                        color: "#ffffff"
                    },
                    onClick: async () => {

                        setDeleting(true);

                        var myHeaders = new Headers();
                        myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
                        myHeaders.append("token", config.domain.PUBLICKEY);
                        myHeaders.append("apikey", user.token);
                        myHeaders.append("cpte", user.code);
                        myHeaders.append("prof", user.profil);
                        myHeaders.append("conn", user.espace);

                        var requestOptions = {
                            method: 'DELETE',
                            headers: myHeaders,
                            // body: urlencoded,
                            redirect: 'follow'
                        };


                        // console.log("data send", urlencoded);
                        await fetch(`${config.domain.BASE_URL}/${config.domain.PROJECT}/nouns/${codetype}`, requestOptions).then((response) => {
                            if (response?.status === 205) {
                                setDeleting(false);
                                showSuccesMessage(textes.fr.typeforfaitdeletedlabel);
                                setEditedstate(false);
                                navigate(-1);
                            } else if (response?.status === 200) {
                                response.json().then(async (data) => {
                                    // console.log("resonse delete", data);
                                    if (data?.body?.data?.msg === "expiredsession") {
                                        logoutUser();
                                        navigate("/", { state: { msg: config.texts.sessionexpmsg } });
                                    } else {
                                        setDeleting(false);
                                        showErrorMessage(data?.body?.data?.msg);
                                    }

                                });
                            } else if (response?.status === 401) {
                                logoutUser();
                                navigate("/", { state: { msg: config.texts.sessionexpmsg } });
                            } else {
                                // setError(true);
                                showErrorMessage(textes.fr.serviceunavaillable);
                                setDeleting(false);
                            }

                        }).catch((err) => {
                            // console.log("error", err);
                            // setError(true);
                            showErrorMessage(textes.fr.serviceunavaillable);
                            setDeleting(false);
                        });
                    }
                },
                {
                    label: textes.fr.cancel,
                    style: {
                        backgroundColor: '#ff0000',
                        color: "#ffffff"
                    },
                    onClick: async () => {
                        // console.log("cancel");
                    }
                }
            ],
            closeOnClickOutside: false
        })
    }

    const handleSubmitEdit = async (e) => {
        e.preventDefault();

        confirmAlert({
            title: textes.fr.edittypeforfaitlabel,
            message: textes.fr.edittypeforfaitlabeldesc,
            buttons: [
                {
                    label: textes.fr.confirm,
                    style: {
                        backgroundColor: '#01203f',
                        color: "#ffffff"
                    },
                    onClick: async () => {

                        setFetching(true);

                        var myHeaders = new Headers();
                        myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
                        myHeaders.append("token", config.domain.PUBLICKEY);
                        myHeaders.append("apikey", user.token);
                        myHeaders.append("cpte", user.code);
                        myHeaders.append("prof", user.profil);
                        myHeaders.append("conn", user.espace);

                        var urlencoded = new URLSearchParams();
                        urlencoded.append("nomtab", "tforfait");
                        urlencoded.append("lib", name);
                        urlencoded.append("abr", abrev);
                        urlencoded.append("defaut", false);
                        urlencoded.append("edit", true);

                        var requestOptions = {
                            method: 'PUT',
                            headers: myHeaders,
                            body: urlencoded,
                            redirect: 'follow'
                        };

                        // console.log("data send", datas)
                        await fetch(`${config.domain.BASE_URL}/${config.domain.PROJECT}/nouns/${codetype}`, requestOptions).then((response) => {
                            if (response?.status === 204) {
                                showSuccesMessage(textes.fr.typeforfaitupdatedlabel);
                                setEditedstate(false);
                                getElement();
                                setFetching(false);
                            } else if (response?.status === 200) {
                                response.json().then(async (data) => {
                                    // console.log("resonse update rule", data);
                                    // let body = data?.body;

                                    if (data?.body?.data?.msg === "expiredsession") {
                                        logoutUser();
                                        navigate("/", { state: { msg: config.texts.sessionexpmsg } });
                                    } else {
                                        setFetching(false);
                                        showErrorMessage(data?.body?.data?.msg);
                                    }

                                });
                            } else if (response?.status === 401) {
                                logoutUser();
                                navigate("/", { state: { msg: config.texts.sessionexpmsg } });
                            } else {
                                // setError(true);
                                showErrorMessage(textes.fr.serviceunavaillable);
                                setFetching(false);
                            }

                        }).catch((err) => {
                            // console.log("error", err);
                            // setError(true);
                            showErrorMessage(textes.fr.serviceunavaillable);
                            setFetching(false);
                        });
                    }
                },
                {
                    label: textes.fr.cancel,
                    style: {
                        backgroundColor: '#ff0000',
                        color: "#ffffff"
                    },
                    onClick: async () => {
                        // console.log("cancel");
                    }
                }
            ],
            closeOnClickOutside: false
        })
    }


    // affichage
    return (
        <div className="row">
            <div className="col-md-12">
                {loading && <Preloader />}
                {!loading && error && <NetworkError />}
                {!loading && !error && <div className="col-md-12" style={{ paddingTop: 8, borderTop: "1px solid #ddd", borderRadius: 8 }}>
                    <div className="row">
                        <div className="col-md-12">
                            <div className="card shadow mb-4">
                                <div className="card-header py-3">
                                    <button onClick={() => navigate(-1)} data-toggle="tooltip" title={textes.fr.back} data-placement="left" className="btn-shadow ml-3 btn btn-dark btn-sm float-right">
                                        <i className="fa fa-reply"></i> <span>{textes.fr.back}</span>
                                    </button>
                                    {(user?.isFullAction || user?.isModifierForfait) && !editedstate && <button onClick={() => setEditedstate(true)}
                                        title={textes.fr.edittypeforfaitlabel}
                                        className="btn-shadow ml-3 btn btn-success btn-sm float-right">
                                        <i className="fa fa-edit mr-1"></i> <span>{textes.fr.edit}</span>
                                    </button>}
                                    {(user?.isFullAction || user?.isSupprimerForfait) && !editedstate && <button onClick={handleDelete}
                                        title={textes.fr.deletetypeforfaitlabel}
                                        className="btn-shadow ml-3 btn btn-danger btn-sm float-right">
                                        <i className="fa fa-trash mr-1"></i> <span>{textes.fr.delete}</span>  {deleting && <Spinner
                                            as="span"
                                            animation="border"
                                            size="sm"
                                            role="status"
                                            aria-hidden="true"
                                        />}
                                    </button>}
                                    <h6 className="m-0 ">{textes.fr.typeforfaitinfoslabel}</h6>
                                </div>
                                <div className="card-body">
                                    <form style={{ width: "100%" }} onSubmit={handleSubmitEdit}>
                                        <div className="row">
                                            <div className="col-md-12 mb-3">
                                                <div className="row">
                                                    <div className="col-md-12 mb-3">
                                                        <label htmlFor="name" className="mb-1">{textes.fr.libellelabel}</label>
                                                        <div className="input-group flex-nowrap">
                                                            <span className="input-group-text" id="name">
                                                                <TextParagraph />
                                                            </span>
                                                            <input type="text"
                                                                className="form-control"
                                                                placeholder={textes.fr.enterlibellelabel}
                                                                value={name}
                                                                onChange={(e) => setName(e.target.value)}
                                                                disabled={editedstate ? false : true}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="col-md-12 mb-3">
                                                        <label htmlFor="abrev" className="mb-1">{textes.fr.abreviationlabel}</label>
                                                        <div className="input-group flex-nowrap">
                                                            <span className="input-group-text" id="abrev">
                                                                <TextParagraph />
                                                            </span>
                                                            <input type="texte"
                                                                className="form-control"
                                                                placeholder={textes.fr.enterabreviationlabel}
                                                                value={abrev}
                                                                onChange={(e) => setAbrev(e.target.value)}
                                                                disabled={editedstate ? false : true}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            {editedstate && <div className="col-md-12 mt-2">
                                                <button type="submit"
                                                    title={textes.fr.editshiftlabel}
                                                    className="btn-shadow ml-3 btn btn-primary btn-sm float-right"
                                                    disabled={name ? false : true}
                                                >
                                                    <i className="fa fa-check mr-2"></i>
                                                    <span>{textes.fr.edit}</span> {fetching && <Spinner
                                                        as="span"
                                                        animation="border"
                                                        size="sm"
                                                        role="status"
                                                        aria-hidden="true"
                                                    />}
                                                </button>
                                                <button onClick={() => setEditedstate(false)}
                                                    title={textes.fr.cancel}
                                                    className="btn-shadow ml-3 btn btn-danger btn-sm float-right">
                                                    <i className="fa fa-reply mr-1"></i> <span>{textes.fr.cancel}</span>
                                                </button>
                                            </div>}
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>}
            </div>
        </div>
    )
}